import { Banner } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/components/Banner.tsx";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/react-i18next@17.1.8_i18next@26.5.10_typescript@6.0.3__react-dom@18.3.1_react@18.3.1__react@18.3.1_typescript@6.0.3/node_modules/react-i18next/dist/es/useTranslation.js";

import type { Me } from "../auth/me";
import { useOnlineStatus } from "./onlineStatus";
import { usePendingCount } from "./pending";

/** Back-compat name used by screens (FE-06/FE-07): the FE-04 online state. */
export const useOnline = useOnlineStatus;

const BACK_ONLINE_MS = 2000;

/**
 * Global offline banner slot (FE-01 FR-FE01-28, FE-04 FR-FE04-29): "Sin conexión…" plus the queued
 * marks of the signed-in user; after reconnecting, "Volvió la conexión." for 2 s. A polite status
 * region that never takes focus.
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  const queryClient = useQueryClient();
  const me = queryClient.getQueryData<Me | null>(["me"]);
  const pending = usePendingCount(me?.user.id);
  // "Volvió la conexión." for 2 s after reconnecting (derived from the online transition).
  const [prevOnline, setPrevOnline] = useState(online);
  const [backOnline, setBackOnline] = useState(false);
  if (online !== prevOnline) {
    setPrevOnline(online);
    setBackOnline(online);
  }
  useEffect(() => {
    if (!backOnline) return;
    const timer = setTimeout(() => setBackOnline(false), BACK_ONLINE_MS);
    return () => clearTimeout(timer);
  }, [backOnline]);

  return (
    <div role="status" aria-live="polite" className="sticky top-0 z-40 empty:hidden">
      {!online ? (
        <div className="px-4 pt-2">
          <Banner
            live={false}
            tone="offline"
            title={t("offline.banner")}
            className="mx-auto max-w-[720px]"
          >
            {pending > 0 ? <p>{t("offline.pending", { count: pending })}</p> : null}
          </Banner>
        </div>
      ) : online && backOnline ? (
        <div className="px-4 pt-2">
          <Banner
            live={false}
            tone="success"
            title={t("offline.back")}
            className="mx-auto max-w-[720px]"
          />
        </div>
      ) : null}
    </div>
  );
}
